import { Box } from "@mui/material";
import AssignedAssetCard from "./AssignedAssetCard";

const AssignedAssets = ({ assets, onAssetClick }) => {
  return (
    <Box
      sx={{
        width: "100%",
        overflowX: "auto",
        pb: 2,
        pt: 2,
        "&::-webkit-scrollbar": { height: "8px" },
        "&::-webkit-scrollbar-track": { backgroundColor: "#F5F5F5", borderRadius: "4px" },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#BDBDBD",
          borderRadius: "4px",
          "&:hover": { backgroundColor: "#9E9E9E" },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 3,
          minWidth: "min-content",
          alignItems: "stretch", 
        }}
      >
        {assets.map((asset) => (
          <Box
            key={asset.id}
            sx={{
              minWidth: { xs: "320px", sm: "380px", md: "420px" },
              maxWidth: { xs: "320px", sm: "380px", md: "420px" },
              display: "flex",
            }}
          >
            <AssignedAssetCard
              asset={asset}
              onClick={() => onAssetClick && onAssetClick(asset.id)}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AssignedAssets;